import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Observable } from 'rxjs';

@Component({
  selector: 'iho-ecolodge-faq-special',
  templateUrl: './ecolodge-faq-special.component.html',
  styleUrls: ['./ecolodge-faq-special.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule, MatExpansionModule, MatIconModule],
  animations: [
    trigger('expandAccordionPanel', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible <=> hidden', animate('500ms ease-in-out')),
    ]),
  ],
})
export class EcolodgeFaqSpecialComponent {
  ecolodgeFaq = [
    {
      title: 'چه نوع ویلاهایی را در مشهد می‌توان رزرو کرد؟',
      description:
        ' ایران هتل آنلاین برای شما مهمانان عزیز، گزینه‌های متنوعی را در نظر گرفته است. ویلا استخردار، روستایی، کوهستانی، ویژه مراسم و ... از جمله ویلاهای مشهد هستند که به راحتی می‌توانید در بخش اول این صفحه انتخاب کرده و رزرو خود را نهایی کنید. '
    },
    {
      title:"جریمه کنسلی ویلاهای مشهد چگونه است؟",
      description:"قوانین کنسلی هر ویلا در مشهد با دیگری متفاوت است. پیش از رزرو می‌توانید در صفحه ویلا موردنظرتان قوانین مربوط به این بخش را مطالعه کرده، سپس رزرو خود را نهایی کنید."
    },
    {
      title: "آیا امکان اجاره ویلا اقتصادی از طریق ایران هتل آنلاین وجود دارد؟",
      description: "بله. برای تمامی بودجه‌ها، ایران هتل آنلاین انتخاب‌های متنوعی را در اختیار مهمانان قرار می‌دهد. شما می‌توانید متناسب با بودجه خود، ویلاهای اقتصادی مشهد را با بهترین قیمت از طریق سایت رزرو کنید. "
    }
    
  ];
}
